import { useMemo } from 'react'
import { AppRoutes } from '@/modules'
import { API_MENU_SERVICE_ENDPOINT } from '@/utils/config'
import { useLazyGetBranchesQuery, useLazyGetUserQuery } from './api'
import { useAuth } from './hooks'
import {
  type MenuItem,
  setActiveCompany,
  setActiveHasBranches,
  setBaseUrl,
  setEmployee,
  setMenuAccess,
  setUser,
  setUserCompanies,
  setUserRoles,
} from './store/app'
import { useAppDispatch } from './store'

export const App = () => {
  const { isAuthenticated } = useAuth()
  const dispatch = useAppDispatch()
  const [getUser] = useLazyGetUserQuery()
  const [getBranches] = useLazyGetBranchesQuery()

  useMemo(async () => {
    if (isAuthenticated) {
      const data = await getUser().unwrap()

      const user = data[0]
      const companies = data[1].companies
      let employee = data[2]
      const activeCompany = companies.find(
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (company: any) => company.id === data[0].activeCompanyId
      )

      // cut out menu conf items
      employee = {
        ...employee,
        roles: [
          {
            ...employee.roles[0],
            role: {
              ...employee.roles[0].role,
              PermissionFrontOnRole: [
                {
                  ...employee.roles[0].role.PermissionFrontOnRole[0],
                  conf: (
                    employee.roles[0].role.PermissionFrontOnRole[0]?.conf || []
                  )
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    .filter((item: any) => {
                      if (item.title === 'ЭПЛ') return false
                      if (item.title === 'Техосмотры') return false
                      return true
                    })
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    .map((item: any) => {
                      if (item.title === 'Аналитика') {
                        return {
                          ...item,
                          // eslint-disable-next-line @typescript-eslint/no-explicit-any
                          subLinks: item.subLinks.filter((item: any) => {
                            if (item.title === 'Топливо') return false
                            if (item.title === 'Пробег') return false
                            if (item.title === 'Заправки') return false
                            return true
                          }),
                        }
                      }
                      return item
                    }),
                },
              ],
            },
          },
          ...employee.roles.slice(1),
        ],
      }

      /*await getBranches({
        companyId: Number(activeCompany?.id),
        params: {
          parentIds: 0,
        },
      }).then((response) => {
        dispatch(setActiveHasBranches(Boolean(response?.data?.length)))
      })*/

      console.log('user', user)
      console.log('employee', employee)
      console.log('activeCompany', activeCompany)

      dispatch(setUser({ ...user, id: employee.id }))
      dispatch(setEmployee(employee))
      dispatch(setUserCompanies(companies))
      dispatch(setActiveCompany(activeCompany))
      dispatch(setBaseUrl(user.activeCompanyBaseUrl))

      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const menuAccess: any = []
      employee?.roles[0]?.role.PermissionFrontOnRole[0]?.conf.forEach(
        (item: MenuItem) => {
          if (item?.url !== undefined) {
            menuAccess.push({
              ...item.url,
              pathname: item.url.pathname.split('/')[1],
            })
          }
          if (item?.subLinks !== undefined) {
            item?.subLinks.forEach((item: MenuItem) => {
              if (item?.url !== undefined) {
                menuAccess.push({
                  ...item.url,
                  pathname: item.url.pathname?.split('/')[1],
                })
              }
            })
          }
        }
      )
      menuAccess.push({
        access: ['ADMIN'],
        pathname: '/development',
      })
      dispatch(setMenuAccess(menuAccess))

      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const userRoles = employee?.roles?.map((item: any) => item?.role?.name)
      console.log('userRoles', userRoles)
      dispatch(setUserRoles(userRoles ?? []))
    }
  }, [isAuthenticated])

  return <AppRoutes />
}

export default App
